import { OfferOriginEnum, StandardPartOfferResponseDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';

export function extractBestLeadTime(offers: StandardPartOfferResponseDTO[]): {
    leadTime: number | undefined;
    origin: OfferOriginEnum | undefined;
} {
    let bestLeadTime: number | undefined = undefined;
    let bestOfferOrigin: OfferOriginEnum | undefined = undefined;
    for (const offer of offers) {
        const leadTime = offer.availability.factory_lead_time_days ?? undefined;
        const origin = offer.origin.origin;
        if (!isPresent(bestLeadTime)) {
            bestLeadTime = leadTime;
            bestOfferOrigin = origin;
            continue;
        }
        if (!isPresent(leadTime)) {
            continue;
        }
        if (leadTime < bestLeadTime) {
            bestLeadTime = leadTime;
            bestOfferOrigin = origin;
        }
    }

    return { leadTime: bestLeadTime, origin: bestOfferOrigin };
}
